export default {
    show: 'Mostrar',
    'archived': 'archivado',
    'revolved': 'Trasladado',
    'locked': 'Bloqueado',
    active: 'Activo',
    'no-$-financial-files': 'Sin archivos financieros',

    'revolved-to-$': 'Trasladado a {financialFile}',
}